export enum CreationTypeEnum {
  AUTOMATIC = 'S',
  MANUAL = 'M',
}
